"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/TeamPage/InfoTab/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);





var _org = require('shared/selectors/org');
var _team = require('shared/selectors/team');
var _phone = require('shared/services/phone');
var _hooks = require('web/services/hooks');

var _Avatar = require('web/components/Avatar');
var _components = require('web/screens/Directory/TeamPage/components');
var _hooks3 = require('web/screens/Directory/TeamPage/hooks');
var _InfoSection = require('./InfoSection'); var _InfoSection2 = _interopRequireDefault(_InfoSection);
var _MembersSection = require('./MembersSection'); var _MembersSection2 = _interopRequireDefault(_MembersSection);
var _TeamLogoSection = require('./TeamLogoSection'); var _TeamLogoSection2 = _interopRequireDefault(_TeamLogoSection);











const Status = ({ isOn, children }) => (
  _react2.default.createElement('li', { className: "team-page--summary--item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}
    , _react2.default.createElement(_components.StatusPill, { tone: isOn ? 'on' : 'off', __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}},  isOn ? 'On' : 'Off' )
    ,  children 
  )
)

// Loads the team's keywords; rendered only for teams whose org has keywords.
const KeywordsStatus = ({ teamKey }) => {
  const { settings, isLoaded } = _hooks3.useTeamReplySettings.call(void 0, teamKey)
  if (!isLoaded) return null
  const words = settings.Keywords.map(k => k.Keyword)
  return (
    _react2.default.createElement('li', { className: "team-page--summary--item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}
      , _react2.default.createElement(_components.StatusPill, { tone: "count", __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}},  words.length )
      ,  words.length ? `Keyword${words.length === 1 ? '' : 's'}: ${words.join(', ')}` : 'No keywords' 
    )
  )
}

const reachesMembers = (count) => {
  if (count === 1) return 'Texts and calls to this number reach its one member.'
  if (count === 2) return 'Texts and calls to this number reach both members.'
  return `Texts and calls to this number reach all ${count} members.`
}

const TeamInfoTab = ({
  teamKey,
  orgKey,
  conversationKey,
  canEditTeam,
  canExportPhoneLogs,
  canSeeKeywords,
  onUpdateInfo,
}) => {
  const orgName = _hooks.useAppSelector.call(void 0, state => _nullishCoalesce(_optionalChain([_org.selectOrgByKey.call(void 0, orgKey, state), 'optionalAccess', _ => _.Name]), () => ( '')))
  const team = _hooks.useAppSelector.call(void 0, state => _team.selectTeamByKey.call(void 0, state, teamKey))
  const teamName = _nullishCoalesce(_optionalChain([team, 'optionalAccess', _2 => _2.Name]), () => ( ''))
  const phoneNumber = _nullishCoalesce(_optionalChain([team, 'optionalAccess', _3 => _3.PhoneNumber]), () => ( ''))
  const membersCount = team ? Object.keys(team.Members).length : 0

  // Families only reach a team that has a number.
  const preview = phoneNumber && (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('div', { className: "team-page--contact", __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}
        , _react2.default.createElement(_Avatar.TeamAvatar, { teamKey: teamKey, size: 64, __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}} )
        , _react2.default.createElement('div', { className: "team-page--contact--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}},  teamName )
        , _react2.default.createElement('div', { className: "team-page--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}},  _phone.formatPhoneNumber.call(void 0, phoneNumber) )
        , _react2.default.createElement('div', { className: "team-page--contact--actions", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}}
          , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 78}}, "💬 Text" )
          , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}, "📞 Call" )
        )
      )
      , _react2.default.createElement('ul', { className: "team-page--summary", 'aria-label': "Settings families notice"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}}
        ,  _optionalChain([team, 'optionalAccess', _4 => _4.NoReply])
          ? _react2.default.createElement(Status, { isOn: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}, "No-reply mode" )
          : _react2.default.createElement(Status, { isOn: !!_optionalChain([team, 'optionalAccess', _5 => _5.AutoReply]), __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}}, "Out-of-office reply" ) 
        ,  canSeeKeywords && _react2.default.createElement(KeywordsStatus, { teamKey: teamKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}} ) 
        , _react2.default.createElement(Status, { isOn: !!_optionalChain([team, 'optionalAccess', _6 => _6.ForwardingNumber]), __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}}, "Call forwarding" )
      )
    )
  )

  return (
    _react2.default.createElement(_components.TabFrame, { preview: preview || undefined, caption: reachesMembers(membersCount), __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}}
      , _react2.default.createElement(_InfoSection2.default, {
        teamKey: teamKey,
        teamName: teamName,
        phoneNumber: phoneNumber,
        orgKey: orgKey,
        orgName: orgName,
        canEditTeam: canEditTeam,
        canExportPhoneLogs: canExportPhoneLogs,
        onUpdateInfo: onUpdateInfo, __self: this, __source: {fileName: _jsxFileName, lineNumber: 94}}
      )
      , _react2.default.createElement(_TeamLogoSection2.default, { teamKey: teamKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 104}} )
      , _react2.default.createElement(_MembersSection2.default, {
        teamKey: teamKey,
        teamName: teamName,
        orgKey: orgKey,
        conversationKey: conversationKey,
        canEditTeam: canEditTeam,
        membersCount: membersCount, __self: this, __source: {fileName: _jsxFileName, lineNumber: 105}}
      )
    )
  )
}

exports. default = _react.memo.call(void 0, TeamInfoTab)
